import Popover from '@idui/react-popover';
import { Button } from 'components/ui'
import React, { useContext } from 'react'
import { TbLockBolt, TbRocket } from 'react-icons/tb'
import useDarkMode from 'utils/hooks/useDarkMode';
import PlusModal from './PlusModal';
import { ModalContext } from 'contexts/ModalContext';
import { BsStars } from 'react-icons/bs';
import { AppSumoContext } from 'contexts/AppSumoContext';
import Subscription from 'views/subscription';
import { PriorityModalContext } from 'contexts/PriorityModalContext';
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';
import { APPSUMO_STUDIO_URL, isAppSumoStudioCampaignLive } from 'components/ui/utils/constant';

export default function PlusBadge({
  className = "",
  wrapperClassName = "",
  feature = "",
  placement = "top",
  content = undefined
}) {

  const { openModal } = useContext(ModalContext);
  const { openModalPriority } = useContext(PriorityModalContext);
  const { isSumoling } = useContext(AppSumoContext);
  const [ isDark ] = useDarkMode();
  const { whitelabel, isWhitelabel } = useWhitelabel();

  if (isWhitelabel) return null;

  const sumoling = isSumoling();
  // While the studio campaign is live, the AppSumo lifetime license is the canonical upgrade
  // path for every user — including sumolings, who can still buy a license to expand limits.
  const studioLive = isAppSumoStudioCampaignLive();

  const handleOnClick = (e) => {
    if (!isWhitelabel) {
      if (studioLive) {
        window.open(APPSUMO_STUDIO_URL, '_blank', 'noopener,noreferrer');
      } else if (sumoling) {
        openModal(<PlusModal />, 650, true, true, "relative !overflow-visible !overflow-y-visible !p-0 !bg-transparent")
      } else {
        openModalPriority(<Subscription isModal={true} />, 1200, true, true, `!p-0 !bg-tertiary-100 dark:!bg-gray-900 zoom-95`);
      }
    }
    e?.stopPropagation();
  }

  return (
    <>
      <Popover
        placement={placement}
        arrowColor={isDark ? 'black' : 'white'}
        className={`max-w-[300px] !border-0 flex flex-col dark:bg-black dark:text-tertiary-50 bg-secondary-500 drop-shadow-xl !p-0 text-tertiary-900`}
        content={
          <div
            onClick={(e) => e.stopPropagation()}
            className='divide-y divide-black/10 dark:divide-white/20'
          >
            <div className='p-2.5 flex items-start gap-2'>
              <TbLockBolt
                className={`${studioLive ? 'text-yellow-500' : !sumoling ? 'text-primary-600' : 'text-fuchsia-500'} text-2xl shrink-0 mt-1`}
              />
              <span className='text-sm'>
                {studioLive ? (
                  <b>
                    Get a lifetime AppSumo license to unlock this feature.
                  </b>
                ) : sumoling ? (
                  <b>
                    Upgrade your account to {whitelabel?.name}&nbsp;
                    <span className='plus text-ai'>Plus</span>&nbsp;
                    <BsStars className='text-pink-500 inline-block -mt-1 mr-1' />
                    to unlock this feature.
                  </b>
                ) : (
                  <b>
                    Upgrade your account to unlock this feature.
                  </b>
                )}
                <span>&nbsp;Get <i>{feature}</i> and more!</span>
              </span>
            </div>
            <div className='p-2.5'>
              <Button
                variant={!studioLive && sumoling ? "ai" : "solid"}
                size="sm"
                className={`w-full !rounded-xl flex items-center justify-center gap-1 ${studioLive ? '!bg-black hover:!bg-gray-900 !text-white !border !border-gray-700' : ''}`}
                onClick={handleOnClick}
              >
                {studioLive ? (
                  <>
                    <img src="/img/others/appsumo.webp" alt="AppSumo" className="w-4 !h-auto" />
                    Get License on AppSumo
                  </>
                ) : sumoling ? (
                  <>
                    Get {whitelabel?.name}
                    <span className='plus'>Plus</span>
                    <BsStars />
                  </>
                ) : (
                  <>
                    <TbRocket className='text-xl' />
                    Upgrade Now
                  </>
                )}
              </Button>
            </div>
          </div>
        }
      >
        {content || (
          <div className={`${wrapperClassName}`}>
            <TbLockBolt
              onClick={handleOnClick}
              className={`transition-all ${studioLive ? 'text-yellow-500 hover:text-yellow-400' : !sumoling ? 'text-primary-600 hover:text-primary-700' : 'text-fuchsia-500 hover:text-pink-500'} text-xl cursor-pointer ${className}`}
            />
          </div>
        )}
      </Popover>
    </>
  )
}
